/**
 * An Online token routes dictionary
 */
export let TokenRoutes = /*#__PURE__*/function (TokenRoutes) {
  TokenRoutes["PUBLIC_ACCESS"] = "/system/ajax/ApiGateway/GetSpaTokenAsync";
  TokenRoutes["USER_ACCESS"] = "/system/ajax/ApiGateway/GetUserAccessTokenAsync";
  return TokenRoutes;
}({});
//# sourceMappingURL=TokenRoutes.js.map